var _path, _circle, _circle2, _circle3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuHorizontal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 44,
    viewBox: "0 0 43 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.21875 0.538086H43.1907V43.51H5.76352C2.70123 43.51 0.21875 41.0275 0.21875 37.9653V0.538086Z",
    fill: "black",
    fillOpacity: 0.67
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.5523,
    cy: 21.6641,
    r: 1.59965,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.3626,
    cy: 21.6641,
    r: 1.59965,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 29.1729,
    cy: 21.6641,
    r: 1.59965,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuHorizontal);
export default __webpack_public_path__ + "static/media/menu-horizontal.4b24c055079787cbf8e0a117133cc564.svg";
export { ForwardRef as ReactComponent };